import { render, staticRenderFns } from "./ClassMessage.vue?vue&type=template&id=8d2c992e&scoped=true&"
import script from "./ClassMessage.vue?vue&type=script&lang=js&"
export * from "./ClassMessage.vue?vue&type=script&lang=js&"
import style0 from "./ClassMessage.vue?vue&type=style&index=0&id=8d2c992e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2c992e",
  null
  
)

export default component.exports